import React, { useEffect, useState, useRef } from "react";
import styles from "./style.module.scss";
import { getDashboardStatsData } from "../../../../../api";
import useDashboardStore from "../../../../stores/dashboard";
import TrendUp from "../../../../assets/svg/icons/common/TrendUp";
import TrendDown from "../../../../assets/svg/icons/common/TrendDown";
import SkeletonLoader from "../../../../components/skeleton-loader";
import TotalVolumeIcon24 from "../../../../assets/svg/icons/common/TotalVolumeIcon24";
import StoreIcon24 from "../../../../assets/svg/icons/common/StoreIcon24";
import FilesIcon24 from "../../../../assets/svg/icons/common/FilesIcon24";
import ArrowRightBlue16 from "../../../../assets/svg/icons/common/ArrowRightBlue16";

const TrendPercentageDisplay = ({ percentage }) => {
  const icon =
    percentage > 0 ? <TrendUp /> : percentage < 0 ? <TrendDown /> : null;
  const isPercentageZero = percentage !== undefined && percentage == 0;

  return (
    <>
      <span
        className={`${styles.statsDescriptionPercentage} ${
          percentage < 0 ? styles.statsDescriptionPercentageDown : ""
        }`}
      >
        {icon} {!isPercentageZero && `${percentage}%`}
      </span>

      <span className={styles.descriptionText}>
        {isPercentageZero && "No change "}
        from last period
      </span>
    </>
  );
};

const Stats = () => {
  const [statsData, setStatsData] = useState({});
  const filterUser = useDashboardStore((s) => s.filterData.filterUser);
  const filterOrg = useDashboardStore((s) => s.filterData.filterOrg);
  const filterStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterEndDate = useDashboardStore((s) => s.filterData.endDate);
  const [statsDataLoading, setStatsDataLoading] = useState(true);
  const carouselRef = useRef(null);

  useEffect(() => {
    setStatsDataLoading(true);
    getDashboardStatsData({
      start_date: filterStartDate,
      end_date: filterEndDate,
      user_id: filterUser,
      org_id: filterOrg,
    })
      .then((res) => {
        setStatsData(res.data);
        setStatsDataLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [filterStartDate, filterEndDate, filterUser, filterOrg]);

  const getStatItems = () => {
    return [
      {
        title: "Total volume",
        value: statsData?.total_sales?.value?.toLocaleString() || "0",
        percentage: statsData?.total_sales?.percentage,
        icon: <TotalVolumeIcon24 />,
      },
      {
        title: "Active merchants",
        value: statsData?.active_merchants_count?.value?.toLocaleString() || 0,
        percentage: statsData?.active_merchants_count?.percentage,
        icon: <StoreIcon24 />,
      },
      {
        title: "Non-Active Merchants",
        value: statsData?.non_active_merchants_count?.toLocaleString() || 0,
        percentage: null,
        icon: <StoreIcon24 />,
      },
      {
        title: "Applications",
        value: statsData?.all_applications_count?.value?.toLocaleString() || 0,
        percentage: statsData?.all_applications_count?.percentage,
        icon: <FilesIcon24 />,
      },
    ];
  };

  const statItems = getStatItems();

  if (statsDataLoading) {
    return (
      <div className={styles.statsContainer}>
        <div className={styles.carousel_wrapper}>
          <div className={styles.carousel_track}>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={`${styles.statsItem} ${styles.card}`}>
                <SkeletonLoader variant="text" height={"123px"} width={"100%"} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.statsContainer}>
      <div className={styles.carousel_wrapper} ref={carouselRef}>
        <div className={styles.carousel_track}>
          {statItems.map((item, index) => (
            <div key={index} className={`${styles.statsItem} ${styles.card}`}>
              <div className={styles.statsHeader}>
                <span>{item.title}</span>
                <span>{item.icon}</span>
              </div>
              <div className={styles.statsContent}>
                <p className={styles.statsText}>
                  {item.title === "Total volume" ? `$ ${item.value}` : item.value}
                </p>
              </div>
              <div className={styles.statsDescription}>
                <div className={styles.descLeft}>
                  {item.percentage !== null && item.percentage !== undefined && (
                    <TrendPercentageDisplay percentage={item.percentage} />
                  )}
                </div>
                {item.title === "Applications" && item.percentage !== null && item.percentage !== undefined && (
                  <div className={styles.statsDescriptionIcon}>
                    <ArrowRightBlue16 />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Stats;
